<template>
  <Fragment>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="时间维度统计" name="first">
        <template v-if="$route.name !== 'timeTJ'">
          <router-view></router-view>
        </template>
        <section class="container" v-else>
          <Breadcrumb />
          <div class="card-wrap mt-20 mb-20">
            <section class="card-content">
              <div class="left">
                <div class="search-name mr-20">
                  <span>时间：</span>
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    placeholder="选择日期时间"
                    style="width:160px"
                    value-format=" yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
                <div class="search-name mr-20">
                  <span>至：</span>
                  <el-date-picker
                    v-model="endDate"
                    type="date"
                    placeholder="选择日期时间"
                    style="width:160px"
                    value-format=" yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
                <el-button
                  type="primary"
                  class="ml-20"
                  @click="searchTimeTJInfo"
                  >查询</el-button
                >
                <el-button type="primary" class="mr-20" @click="exportTimeTJ"
                  >下载</el-button
                >
              </div>
            </section>
          </div>
          <div class="card-wrap mt-20 mb-20">
            <span style="font-weight:bold">拍码总数：{{ sumNum }}</span>
          </div>
          <el-table :data="list" style="width: 150%" border>
            <el-table-column label="序号" width="100">
              <template slot-scope="scope">
                <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="年" width="300">
              <template slot-scope="scope">
                <span>{{ scope.row.year }}</span>
              </template>
            </el-table-column>
            <el-table-column label="月" width="300">
              <template slot-scope="scope">
                <span>{{ scope.row.month }}</span>
              </template>
            </el-table-column>
            <el-table-column label="日" width="300">
              <template slot-scope="scope">
                <span>{{ scope.row.day }}</span>
              </template>
            </el-table-column>
            <el-table-column label="拍码数">
              <template slot-scope="scope">
                <span>{{ scope.row.number }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20 pagination"
            background
            layout="total,prev, pager, next, jumper"
            :total="total"
            :page-size="10"
            :current-page="pageNum"
            @prev-click="handlePrePage"
            @next-click="handleNextPage"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </section>
      </el-tab-pane>
      <el-tab-pane label="时间维度统计图表" name="second">
        <div class="card-wrap mt-20 mb-40">
          <span
            style="font-size:25px;font-weight:bold;text-align: center;display:block;color: darkblue"
            >时间维度统计表 拍码数：{{ sumNum }}
          </span>
        </div>
      </el-tab-pane>
    </el-tabs>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      activeName: "first",
      sumNum: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getTimeTJList() {
      let _this = this;
      let param = {
        url: "/api/productNewTJTime/getProductNewTjTimePage",
        params: {
          startDate: _this.startDate,
          endDate: _this.endDate,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getTimeTJList", param).then(() => {
        _this.list = _this.$store.state.shootTJ.timeTJList.list;
        _this.total = _this.$store.state.shootTJ.timeTJList.total;
        if (_this.list.length > 0) {
          _this.sumNum = _this.list[0].sumNum;
        } else {
          _this.sumNum = 0;
        }
      });
    },
    //查询
    searchTimeTJInfo() {
      let _this = this;
      _this.getTimeTJList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getTimeTJList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getTimeTJList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getTimeTJList();
    },
    //下载
    exportTimeTJ() {
      let _this = this;
      let param = {
        startDate: _this.startDate,
        endDate: _this.endDate
      };
      _this.$Api
        .post("/api/productNewTJTime/exportProductNewTjTime", param)
        .then(response => {
          if (response.status === 200) {
            _this.$Api.exportExcel(
              ["拍码总数", "年", "月", "日", "拍码数"],
              ["sumNum", "year", "month", "day", "number"],
              response.data,
              "NewProducts_TimeTJ"
            );
          } else {
            _this.$message({
              message: "无法获取导出数据",
              type: "warning"
            });
          }
        });
    }
  },
  created() {
    let _this = this;
    _this.getTimeTJList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
